import { stringToBoolOrDefault } from "@microsoft/applicationinsights-common";
import { isatty } from "tty";

export class TemplateField {
    Name:string;
    Description:string;
    Type:string;
    Required:boolean;
    Length:string;
    Options:Array<string>;
};
export class Template {
    id:string;
    Name:string;
    Description:string;
    Layout:string;
    Fields:TemplateField[];
};

export class CaseViewModel
{
    Template:Template;
    Data:any;
    IsDisplay:boolean;
    changeset:any;
    OnChange:()=>void;
}

export class Dashboard
{
    total: number;
    cases: Case[];
    page: number;
}


export class OFRResponse
{
    Result:string;
    ErrorMessage:string[];
    Extra:any;
}

export class Case {
  id: string;
  OCME: string;
  Status: string;
  Jurisdiction: string;
  UpdatedOn: string;
  Template: string;
  Flagged: boolean;
  DrugsInSystem: string[];
  Data: any;
  OCMEData: any;
  HasComments: any;
};
export class SearchCase {
  public dateOfDeathFrom: string;
  public dateOfDeathTo: string;
  public dateOfBirthFrom: string;
  public dateOfBirthTo: string;
  public lastName: string = '';
  public ocme: string = '';
  public residentCounty: string = '';
  public incidentCounty: string = '';
  public NonFatal: boolean = false;
  public Fatal: boolean = false;
  public isArchived: boolean = false;
  public hasUnresolvedMessages: boolean;
  public hasUnreadMessages: boolean;
  public flaggedOnly: boolean = false;
  public sortByProperty: string = "Default";
  public isAscending: boolean = true;

  constructor(sortBy: string = "Default", isAsc: boolean = true)
  {
    if (sortBy !== null && sortBy !== undefined && sortBy.length > 0)
    {
        this.sortByProperty = sortBy;
    }

    this.isAscending = isAsc;
  }
};

export class CaseFilter extends SearchCase {
  public page: number = 1;
  public status: string;
  public size: number;
  public flaggedOnly: boolean;
  public isNonFatal:boolean = null;
  public sortByProperty:string = "Default";
  public isAscending:boolean = true;
};
export class PingCase
{
    Result:string;   
    Data:string[];
}
export class CaseByPageModel
{
    Count: number;
    Cases: Case[];
    OverDueCount: number;
    page: number;
}

